document.addEventListener('DOMContentLoaded', () => {

    const mobile = document.querySelector('.nava-mobile');

    if (!mobile) return;

    const openButton = mobile.querySelector('.nava-mobile-toggle');
    const closeButton = mobile.querySelector('.nava-mobile-close');
    const overlay = mobile.querySelector('.nava-mobile-overlay');

    function openMenu(){

        mobile.classList.add('open');

        document.body.style.overflow='hidden';

    }

    function closeMenu(){

        mobile.classList.remove('open');

        document.body.style.overflow='';

    }

    openButton.addEventListener('click',openMenu);

    closeButton.addEventListener('click',closeMenu);

    overlay.addEventListener('click',closeMenu);

});